import { i18n, Translations } from "@i18n";
import * as yup from "yup";
import { ForgotPasswordFormValues } from "./types";

export const validationSchema: yup.SchemaOf<ForgotPasswordFormValues> = yup.object().shape({
  email: yup
    .string()
    .email(i18n.t(Translations.ForgotPasswordRouteEmailInvalid))
    .required(i18n.t(Translations.ForgotPasswordRouteEmailRequired)),
});
